import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import BrandKitManager from '../components/BrandKitManager';
import BrandKitForm from '../components/BrandKitForm';
import { useBrandKit } from '../contexts/BrandKitContext';

const BrandKitPage = () => {
  const [searchParams] = useSearchParams();
  const editId = searchParams.get('edit');
  const [showForm, setShowForm] = useState(!!editId);
  const [editingKit, setEditingKit] = useState(null);
  const { brandKits, getBrandKit } = useBrandKit();

  useEffect(() => {
    if (editId) {
      const kit = getBrandKit(editId);
      if (kit) {
        setEditingKit(kit);
        setShowForm(true);
      }
    }
  }, [editId, getBrandKit]);

  const handleCreateNew = () => {
    setEditingKit(null);
    setShowForm(true);
  };

  const handleEdit = (kit) => {
    setEditingKit(kit);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingKit(null);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Brand Kit</h1>
          <p className="text-gray-600">Create and manage your brand identity</p>
        </div>

        {showForm ? (
          <BrandKitForm
            editingKit={editingKit}
            onClose={handleCloseForm}
          />
        ) : (
          <BrandKitManager
            onCreateNew={handleCreateNew}
            onEdit={handleEdit}
          />
        )}
      </motion.div>
    </div>
  );
};

export default BrandKitPage;